module.exports = __webpack_public_path__ + "img/no-goods.d8641c80.png";